import React from "react";
import StepPlaceholder from "./StepPlaceholder";

interface StepProps {
  onBack: () => void;
  onNext: () => void;
}

const Step2TestConfiguration: React.FC<StepProps> = ({
  onBack,
  onNext,
}) => {
  return (
    <StepPlaceholder
      step={2}
      label={
        <>
          Test
          <div>Configuration</div>
        </>
      }
      onBack={onBack}
      onNext={onNext}
    />
  );
};

export default Step2TestConfiguration;